import React from 'react';
import TabBar from './TabBar';
import { Link, Outlet } from 'react-router';
import Onboarding from './onbording/Onboarding';
import { useTelegram } from '../contexts/TelegramContext';
import { RootPathes, UserData } from '../types';

type Props = {
  user: UserData;
}

const Layout: React.FC<Props> = ({ user }) => {
  const { tgUser } = useTelegram();

  return (
    <div className='min-h-screen bg-gradient-to-br from-green to-neon-green'>
      <div className='mx-auto flex h-full max-w-2xl flex-col'>
        {user && (
          <header className='flex flex-shrink-0 flex-col px-4 py-2'>
            <div className='flex flex-row items-center justify-between gap-2'>
              <h1 className='flex flex-col text-2xl font-semibold text-black'>
                {`Hello, ${user.firstName}`}
              </h1>

              {tgUser?.photo_url && (
                <Link to={RootPathes.CONFIG}>
                  <img
                    src={tgUser.photo_url}
                    alt='Profile'
                    className='h-12 w-12 rounded-full shadow-glow-inset ring-2 ring-white'
                  />
                </Link>
              )}
            </div>

            <div className='mb-3 text-sm font-medium text-black'>
              Monetise your digital behaviour
            </div>

            {!user.onboardingCompleted && <Onboarding user={user}/>}
          </header>
        )}

        <div
          className={`
            flex flex-1 rounded-t-[32px] bg-linear-dark px-[1px] pt-[1px] transition-all
            duration-500 ease-in-out
          `}
        >
          <div
            className={`
              from-gray-950 via-gray-900 to-gray-950 flex w-full flex-1 flex-col rounded-t-[32px]
              bg-gradient-to-br p-4
            `}
          >
            <TabBar />

            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
